import React, { useState, useEffect } from "react";
import { db } from "../../../context/Firebase";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import "./Quickreads.css"
import BackButton from "../../../shared/components/Backbtn";

const QuickReadsCategory = () => {
  const [categories, setCategories] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      const querySnapshot = await getDocs(collection(db, "quick-reads-category"));
      const fetchedCategories = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().name,
      }));
      setCategories(fetchedCategories);
    };
    fetchCategories();
  }, []);

  const saveData = async () => {
    if (inputValue.trim() !== "") {
      try {
        const docRef = await addDoc(collection(db, "quick-reads-category"), { name: inputValue });
        setCategories([...categories, { id: docRef.id, name: inputValue }]);
        setInputValue("");
      } catch (error) {
        console.error("Error adding document: ", error);
      }
    }
  };

  const deleteCategory = async (id) => {
    try {
      await deleteDoc(doc(db, "quick-reads-category", id));
      setCategories(categories.filter((category) => category.id !== id));
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  return (
    <div className="quickreads-container">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
        <BackButton tooltip="Back" />
      </div>
      <h2 className="quickreads-heading">Manage Quick Reads Categories</h2>

      <div className="quickreads-input-group">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Enter category name"
        />
        <button onClick={saveData}>Add Category</button>
      </div>

      <table className="quickreads-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Category Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.length === 0 ? (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", color: "#666", padding: "16px" }}>
                No categories available
              </td>
            </tr>
          ) : (
            categories.map((category, index) => (
              <tr key={category.id}>
                <td>{index + 1}</td>
                <td>{category.name}</td>
                <td style={{ textAlign: "center" }}>
                  <button
                    onClick={() => deleteCategory(category.id)}
                    className="quickreads-delete-button"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default QuickReadsCategory;
